<aside class="sidebar" [ngClass]="{ 'sidebar--visible': sidebarVisible }">
  <ng-content></ng-content>
  <p-button
    class="sidebar__button"
    styleClass="p-button-rounded p-button-primary"
    (click)="toggleSidebar()">
    <fa-icon [icon]="sidebarVisible ? faArrowLeft : faArrowRight"></fa-icon
  ></p-button>
</aside>
